let hostname = window.location.hostname;
let protocol = window.location.protocol;
let getLang = localStorage.getItem('default_lang') ?? 'en';

// Get the places data
async function getAreas() {
    try {
        const response = await fetch(`${protocol ? protocol : 'http:'}//${hostname}/server/api.php?endpoint=places&language=${localStorage.getItem('default_lang') ? localStorage.getItem('default_lang') : 'en'}`);
        const data = await response.json();
        return data;
    } catch (err) {
        console.log(err);
    }
}

// Get the types data
async function getTypes() {
    try {
        const response = await fetch(`${protocol ? protocol : 'http:'}//${hostname}/server/api.php?endpoint=types&language=${localStorage.getItem('default_lang') ? localStorage.getItem('default_lang') : 'en'}`);
        const data = await response.json();
        return data;
    } catch (err) {
        console.log(err);
    }
}

// Load Data
var data = getAreas();
var typesData = getTypes();
var map;
var markers = [];
var currentProperty;

// Initialize the map
function initMap() {
    var grayMapStyles = [
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#d3d3d3"
                }
            ]
        },
        {
            "featureType": "transit",
            "stylers": [
                {
                    "color": "#808080"
                },
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#b3b3b3"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffffff"
                },
                {
                    "weight": 1.8
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#d7d7d7"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ebebeb"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#a7a7a7"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#efefef"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#696969"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#737373"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#d6d6d6"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {},
        {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#dadada"
                }
            ]
        }
    ];

    data.then(() => {
        try {
            let initArea = 'all';
            let initPropertyType = 'all';
            let initLat = 29.9064723;
            let initLng = 33.7278179;
            currentProperty = initPropertyType;

            map = new google.maps.Map(document.getElementById('map'), {
                center: {
                    lat: initLat,
                    lng: initLng
                },
                zoom: 8, // Adjust the zoom level as needed
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: true,
                fullscreenControl: false,
                styles: grayMapStyles
            });

            // Initially load markers for default property type and area
            loadMarkers(initArea, currentProperty);
        } catch (err) {
            console.log(err);
        }
    });
}

// Generate areas dropdown <option>
var areaDropdown = document.getElementById('area-dropdown');

let texts = {
    'all': 'الكل',
    'Rafah': 'رفح',
    'Sheikh Zuwied': 'الشيخ زويد',
    'Al-Arish': 'العريش',
    'Bir Al-Abd': 'بئر العبد',
    'Al-Hasna': 'الحسنة',
    'Al-Hassana': 'الحسنة',
};

try {
    data.then((res) => {
        var currentOption = 0;

        try {
            for (let key of Object.keys(res)) {
                if (currentOption === 0) {
                    areaDropdown.innerHTML += `<option value="all">${getLang === 'ar' ? texts.all : 'All'}</option>`;
                    currentOption++;
                }

                areaDropdown.innerHTML += `<option value="${key}">${getLang === 'ar' ? texts[key] : key}</option>`;
            }

        } catch (err) {
            console.log(err);
        }
    })

} catch (err) {
    console.log(err);
}

function setInfoWindowContent(theTitle, theDesc, lat, lng, mediaElements, thePlaceType) {
    return `
        <div class="custom-content-info ${thePlaceType}">
            <div class="gm-media-holder">
            ${mediaElements !== undefined ?
            mediaElements.length > 0 ?
                mediaElements.map((singleMedia) => {
                    if (singleMedia.type === 'video' && singleMedia.poster) {
                        return `<a href="${singleMedia.path}" class="video-media" data-fancybox="media"><img src="${singleMedia.poster}"/></a>`
                    } 
                    
                    else if (singleMedia.type === 'video' && (singleMedia.poster === undefined || !singleMedia.poster)) {
                        return `<a href="${singleMedia.path}" class="video-media placeholder video-placeholder" data-fancybox="media"><img src="./sina-logo.png"/></a>`
                    }
                    
                    else {
                        return `<a href="${singleMedia.path}" class="${singleMedia.type === 'video' ? 'video-media' : ''}" data-fancybox="media"><img src="${singleMedia.poster ? singleMedia.poster : singleMedia.path}"/></a>`
                    }
                }).join('') : `<a href="./sina-logo.png" class="placeholder" data-fancybox="media"><img src="./sina-logo.png"/></a>` : ''
            }
            </div>

            <div class="gm-place-title">
                <span>${theTitle}</span>
            </div>

            <span class='gm-place-desc'>${theDesc ? theDesc : getLang === 'ar' ? 'لا يوجد وصف...' : 'No Description...'}</span>

            <a class="gm-get-direction" href="https://www.google.com/maps/search/?api=1&amp;query=${lat}%20${lng}" target="_blank">
                <span>${getLang === 'ar' ? 'احصل على الاتجاه' : 'Get Direction'}</span>
            </a>
        </div>
    `;
}

let isPolygonExist = false;

function loadMarkers(area, propertyType) {
    // Print the property description above the places list 
    let propertyDescTexts = {
        'all': 'Total Attacks',
        'closed_schools': 'Total Closed Schools',
        'destroyed_schools': 'Total Destroyed Schools',
        'military_use_of_schools': 'Total Military Use of Schools'
    }

    if (getLang === 'ar') {
        propertyDescTexts = {
            'all': 'إجمالي الهجمات',
            'closed_schools': 'إجمالي على المدارس المغلقة',
            'destroyed_schools': 'إجمالي على المدارس المدمرة',
            'military_use_of_schools': 'إجمالي الاستخدام العسكري للمدارس'
        }
    }

    let propertyDescElement = document.querySelector('.property-desc');
    propertyDescElement.textContent = propertyDescTexts[propertyType];

    // Clear previous markers
    markers.forEach(function (marker) {
        marker.setMap(null);
    });
    markers = [];

    try {
        data.then((res) => {
            try {
                var places;

                if (area === 'all' && propertyType === 'all') {
                    places = Object.entries(res);
                    for (let [, place] of places) {

                        for (let [placeType, placeCategory] of Object.entries(place)) {
                            const { places } = placeCategory;
                            places.forEach((singlePlace) => {
                                const placesPositions = singlePlace;

                                var marker = new google.maps.Marker({
                                    position: placesPositions.options.position,
                                    map: map,
                                    title: placesPositions.data.title
                                });

                                // Close infowindow when click on the map
                                map.addListener('click', function () {
                                    if (infowindow !== null) {
                                        infowindow.close();
                                        clearMarkerAnimations();
                                    }
                                });

                                function clearMarkerAnimations() {
                                    markers.forEach(function(marker) {
                                        marker.setAnimation(null);
                                    });
                                }

                                marker.addListener('click', function () {
                                    toggleFilters('close');
                                    map.setCenter(marker.getPosition());
                                    let infoWindowContent = setInfoWindowContent(placesPositions.data.title, placesPositions.data.description, placesPositions.options.position.lat, placesPositions.options.position.lng, placesPositions.data.media, placeType);

                                    infowindow.setContent(infoWindowContent);
                                    infowindow.open(map, marker);

                                    // Remove active class from the list to avoid confusion
                                    document.querySelector('.property-items li.active-link')?.classList.remove('active-link');

                                    // Clear any animation on the marker
                                    clearMarkerAnimations();

                                    // Apply animation on the marker
                                    marker.setAnimation(google.maps.Animation.BOUNCE);
                                });

                                // Custom Icon
                                var icon;

                                if (placeType === 'closed_schools') {
                                    icon = { url: './assets/svg/closed_schools.svg', scaledSize: new google.maps.Size(24, 36) };
                                    marker.setIcon(icon);
                                }

                                if (placeType === 'destroyed_schools') {
                                    icon = { url: './assets/svg/destroyed_schools.svg', scaledSize: new google.maps.Size(24, 36) };
                                    marker.setIcon(icon);
                                }

                                if (placeType === 'military_use_of_schools') {
                                    icon = { url: './assets/svg/military_use_of_schools.svg', scaledSize: new google.maps.Size(24, 36) };
                                    marker.setIcon(icon);
                                }

                                markers.push(marker);

                                // Add clickable list item
                                var listItem = document.createElement('li');
                                var listItemSpan = document.createElement('span');
                                listItem.appendChild(listItemSpan);
                                listItemSpan.textContent = placesPositions.data.title;
                                listItem.setAttribute('onclick', 'centerMap(' + marker.getPosition().lat() + ',' + marker.getPosition().lng() + ')');
                                listItem.addEventListener('click', function () {

                                    // Changing the zoom when clicked an item in left hand list
                                    map.setZoom(12);

                                    // Close infowindow when click on the map
                                    map.addListener('click', function () {
                                        if (infowindow !== null) {
                                            infowindow.close();
                                            clearMarkerAnimations();
                                        }
                                    });

                                    let infoWindowContent = setInfoWindowContent(placesPositions.data.title, placesPositions.data.description, placesPositions.options.position.lat, placesPositions.options.position.lng, placesPositions.data.media, placeType);

                                    infowindow.setContent(infoWindowContent);
                                    infowindow.open(map, marker);

                                    // Remove active class from the list to avoid confusion
                                    document.querySelector('.property-items li.active-link')?.classList.remove('active-link');

                                    // Clear any animation on the marker
                                    clearMarkerAnimations();

                                    // Apply animation on the marker
                                    marker.setAnimation(google.maps.Animation.BOUNCE);
                                });

                                listItem.setAttribute('title', placesPositions.data.title);
                                document.getElementById('property-items').appendChild(listItem);
                            });

                        }
                    }

                    // For active/inactive classes on the property items
                    let thePropertyItems = document.querySelectorAll('.property-items li');
                    thePropertyItems.forEach((propertyItem) => {
                        propertyItem.addEventListener('click', function () {
                            toggleFilters('close');
                            thePropertyItems.forEach((pi) => {
                                pi.classList.remove('active-link');
                            });

                            this.classList.add('active-link');
                        })
                    });
                }

                if (area === 'all' && propertyType !== 'all') {
                    places = res;

                    for (let place of Object.values(places)) {
                        if (place[propertyType] == undefined) {
                            continue;
                        }

                        place[propertyType]['places'].forEach((singlePlace) => {
                            const placesPositions = singlePlace;

                            var marker = new google.maps.Marker({
                                position: placesPositions.options.position,
                                map: map,
                                title: placesPositions.data.title
                            });

                            // Close infowindow when click on the map
                            map.addListener('click', function () {
                                if (infowindow !== null) {
                                    infowindow.close();
                                    clearMarkerAnimations();
                                }
                            });

                            function clearMarkerAnimations() {
                                markers.forEach(function(marker) {
                                    marker.setAnimation(null);
                                });
                            }

                            marker.addListener('click', function () {
                                map.setCenter(marker.getPosition());
                                toggleFilters('close');
                                let infoWindowContent = setInfoWindowContent(placesPositions.data.title, placesPositions.data.description, placesPositions.options.position.lat, placesPositions.options.position.lng, placesPositions.data.media, propertyType);

                                infowindow.setContent(infoWindowContent);
                                infowindow.open(map, marker);

                                // Remove active class from the list to avoid confusion
                                document.querySelector('.property-items li.active-link')?.classList.remove('active-link');

                                // Clear any animation on the marker
                                clearMarkerAnimations();

                                // Apply animation on the marker
                                marker.setAnimation(google.maps.Animation.BOUNCE);
                            });

                            // Custom Icon
                            var icon;

                            if (propertyType === 'closed_schools') {
                                icon = { url: './assets/svg/closed_schools.svg', scaledSize: new google.maps.Size(24, 36) };
                                marker.setIcon(icon);
                            }

                            if (propertyType === 'destroyed_schools') {
                                icon = { url: './assets/svg/destroyed_schools.svg', scaledSize: new google.maps.Size(24, 36) };
                                marker.setIcon(icon);
                            }

                            if (propertyType === 'military_use_of_schools') {
                                icon = { url: './assets/svg/military_use_of_schools.svg', scaledSize: new google.maps.Size(24, 36) };
                                marker.setIcon(icon);
                            }

                            markers.push(marker);

                            // Add clickable list item
                            var listItem = document.createElement('li');
                            var listItemSpan = document.createElement('span');
                            listItemSpan.textContent = placesPositions.data.title;
                            listItem.appendChild(listItemSpan);
                            listItem.setAttribute('onclick', 'centerMap(' + marker.getPosition().lat() + ',' + marker.getPosition().lng() + ')');
                            listItem.addEventListener('click', function () {
                                
                                // Changing the zoom when clicked an item in left hand list
                                map.setZoom(12);

                                // Close infowindow when click on the map
                                map.addListener('click', function () {
                                    if (infowindow !== null) {
                                        infowindow.close();
                                        clearMarkerAnimations();
                                    }
                                });

                                let infoWindowContent = setInfoWindowContent(placesPositions.data.title, placesPositions.data.description, placesPositions.options.position.lat, placesPositions.options.position.lng, placesPositions.data.media, propertyType);

                                infowindow.setContent(infoWindowContent);
                                infowindow.open(map, marker);

                                // Remove active class from the list to avoid confusion
                                document.querySelector('.property-items li.active-link')?.classList.remove('active-link');

                                // Clear any animation on the marker
                                clearMarkerAnimations();

                                // Apply animation on the marker
                                marker.setAnimation(google.maps.Animation.BOUNCE);

                            });
                            listItem.setAttribute('title', placesPositions.data.title);
                            document.getElementById('property-items').appendChild(listItem);

                        });
                    }

                    // For active/inactive classes on the property items
                    let thePropertyItems = document.querySelectorAll('.property-items li');
                    thePropertyItems.forEach((propertyItem) => {
                        propertyItem.addEventListener('click', function () {
                            toggleFilters('close');
                            thePropertyItems.forEach((pi) => {
                                pi.classList.remove('active-link');
                            });

                            this.classList.add('active-link');
                        })
                    });
                }

                if (area !== 'all' && propertyType === 'all') {
                    places = res[area];

                    for (let [placeType, place] of Object.entries(places)) {

                        place['places'].forEach((singlePlace) => {
                            const placesPositions = singlePlace;

                            var marker = new google.maps.Marker({
                                position: placesPositions.options.position,
                                map: map,
                                title: placesPositions.data.title
                            });

                            // Close infowindow when click on the map
                            map.addListener('click', function () {
                                if (infowindow !== null) {
                                    infowindow.close();
                                    clearMarkerAnimations();
                                }
                            });

                            function clearMarkerAnimations() {
                                markers.forEach(function(marker) {
                                    marker.setAnimation(null);
                                });
                            }

                            marker.addListener('click', function () {
                                map.setCenter(marker.getPosition());
                                toggleFilters('close');
                                let infoWindowContent = setInfoWindowContent(placesPositions.data.title, placesPositions.data.description, placesPositions.options.position.lat, placesPositions.options.position.lng, placesPositions.data.media, placeType);

                                infowindow.setContent(infoWindowContent);
                                infowindow.open(map, marker);

                                // Remove active class from the list to avoid confusion
                                document.querySelector('.property-items li.active-link')?.classList.remove('active-link');

                                // Clear any animation on the marker
                                clearMarkerAnimations();

                                // Apply animation on the marker
                                marker.setAnimation(google.maps.Animation.BOUNCE);
                            });

                            // Custom Icon
                            var icon;

                            if (placeType === 'closed_schools') {
                                icon = { url: './assets/svg/closed_schools.svg', scaledSize: new google.maps.Size(24, 36) };
                                marker.setIcon(icon);
                            }

                            if (placeType === 'destroyed_schools') {
                                icon = { url: './assets/svg/destroyed_schools.svg', scaledSize: new google.maps.Size(24, 36) };
                                marker.setIcon(icon);
                            }

                            if (placeType === 'military_use_of_schools') {
                                icon = { url: './assets/svg/military_use_of_schools.svg', scaledSize: new google.maps.Size(24, 36) };
                                marker.setIcon(icon);
                            }

                            markers.push(marker);

                            // Add clickable list item
                            var listItem = document.createElement('li');
                            var listItemSpan = document.createElement('span');
                            listItemSpan.textContent = placesPositions.data.title;
                            listItem.appendChild(listItemSpan);
                            listItem.setAttribute('onclick', 'centerMap(' + marker.getPosition().lat() + ',' + marker.getPosition().lng() + ')');
                            listItem.addEventListener('click', function () {
                                // Changing the zoom when clicked an item in left hand list
                                map.setZoom(12);

                                // Close infowindow when click on the map
                                map.addListener('click', function () {
                                    if (infowindow !== null) {
                                        infowindow.close();
                                        clearMarkerAnimations();
                                    }
                                });

                                let infoWindowContent = setInfoWindowContent(placesPositions.data.title, placesPositions.data.description, placesPositions.options.position.lat, placesPositions.options.position.lng, placesPositions.data.media, placeType);

                                infowindow.setContent(infoWindowContent);
                                infowindow.open(map, marker);

                                // Remove active class from the list to avoid confusion
                                document.querySelector('.property-items li.active-link')?.classList.remove('active-link');

                                // Clear any animation on the marker
                                clearMarkerAnimations();

                                // Apply animation on the marker
                                marker.setAnimation(google.maps.Animation.BOUNCE);

                            });
                            listItem.setAttribute('title', placesPositions.data.title);
                            document.getElementById('property-items').appendChild(listItem);

                        });
                    }

                    // For active/inactive classes on the property items
                    let thePropertyItems = document.querySelectorAll('.property-items li');
                    thePropertyItems.forEach((propertyItem) => {
                        propertyItem.addEventListener('click', function () {
                            toggleFilters('close');
                            thePropertyItems.forEach((pi) => {
                                pi.classList.remove('active-link');
                            });

                            this.classList.add('active-link');
                        })
                    });
                }

                if (area !== 'all' && propertyType !== 'all') {
                    if (res[area][propertyType] === undefined) {
                        return;
                    }

                    places = res[area][propertyType]["places"];
                    places.forEach(function (place) {
                        var marker = new google.maps.Marker({
                            position: place.options.position,
                            map: map,
                            title: place.data.title
                        });

                        // Close infowindow when click on the map
                        map.addListener('click', function () {
                            if (infowindow !== null) {
                                infowindow.close();
                                clearMarkerAnimations();
                            }
                        });

                        function clearMarkerAnimations() {
                            markers.forEach(function(marker) {
                                marker.setAnimation(null);
                            });
                        }

                        marker.addListener('click', function () {
                            map.setCenter(marker.getPosition());
                            toggleFilters('close');
                            let infoWindowContent = setInfoWindowContent(place.data.title, place.data.description, place.options.position.lat, place.options.position.lng, place.data.media, propertyType);

                            infowindow.setContent(infoWindowContent);
                            infowindow.open(map, marker);

                            // Remove active class from the list to avoid confusion
                            document.querySelector('.property-items li.active-link')?.classList.remove('active-link');

                            // Clear any animation on the marker
                            clearMarkerAnimations();

                            // Apply animation on the marker
                            marker.setAnimation(google.maps.Animation.BOUNCE);
                        });

                        // Custom Icon
                        var icon;

                        if (propertyType === 'closed_schools') {
                            icon = { url: './assets/svg/closed_schools.svg', scaledSize: new google.maps.Size(24, 36) };
                            marker.setIcon(icon);
                        }

                        if (propertyType === 'destroyed_schools') {
                            icon = { url: './assets/svg/destroyed_schools.svg', scaledSize: new google.maps.Size(24, 36) };
                            marker.setIcon(icon);
                        }

                        if (propertyType === 'military_use_of_schools') {
                            icon = { url: './assets/svg/military_use_of_schools.svg', scaledSize: new google.maps.Size(24, 36) };
                            marker.setIcon(icon);
                        }

                        markers.push(marker);

                        // Add clickable list item
                        var listItem = document.createElement('li');
                        var listItemSpan = document.createElement('span');
                        listItemSpan.textContent = place.data.title;
                        listItem.appendChild(listItemSpan);
                        listItem.setAttribute('onclick', 'centerMap(' + marker.getPosition().lat() + ',' + marker.getPosition().lng() + ')');
                        listItem.addEventListener('click', function () {

                            // Changing the zoom when clicked an item in left hand list
                            map.setZoom(12);
                            
                            // Close infowindow when click on the map
                            map.addListener('click', function () {
                                if (infowindow !== null) {
                                    infowindow.close();
                                    clearMarkerAnimations();
                                }
                            });

                            let infoWindowContent = setInfoWindowContent(place.data.title, place.data.description, place.options.position.lat, place.options.position.lng, place.data.media, propertyType);

                            infowindow.setContent(infoWindowContent);
                            infowindow.open(map, marker);

                            // Remove active class from the list to avoid confusion
                            document.querySelector('.property-items li.active-link')?.classList.remove('active-link');

                            // Clear any animation on the marker
                            clearMarkerAnimations();

                            // Apply animation on the marker
                            marker.setAnimation(google.maps.Animation.BOUNCE);

                        });
                        listItem.setAttribute('title', place.data.title);
                        document.getElementById('property-items').appendChild(listItem);
                    });

                    // For active/inactive classes on the property items
                    let thePropertyItems = document.querySelectorAll('.property-items li');
                    thePropertyItems.forEach((propertyItem) => {
                        propertyItem.addEventListener('click', function () {
                            toggleFilters('close');
                            thePropertyItems.forEach((pi) => {
                                pi.classList.remove('active-link');
                            });

                            this.classList.add('active-link');
                        })
                    });
                }

                var infowindow = new google.maps.InfoWindow({
                    maxWidth: '650'
                });

                const setPolygon = () => {
                    isPolygonExist = true;

                    // Define the coordinates for your area boundary
                    var areaCoordinates = [
                        { lat: 31.323465, lng: 34.218677 },
                        { lat: 31.285299, lng: 34.161732 },
                        { lat: 31.247515, lng: 34.188400 },
                        { lat: 31.230836, lng: 34.202487 },
                        { lat: 31.220278, lng: 34.209947 },
                        { lat: 31.203066, lng: 34.210556 },
                        { lat: 31.202127, lng: 34.205000 },
                        { lat: 31.197079, lng: 34.205141 },
                        { lat: 31.196850, lng: 34.230021 },
                        { lat: 31.196859, lng: 34.255561 },
                        { lat: 31.197087, lng: 34.269380 },
                        { lat: 31.196894, lng: 34.275020 },
                        { lat: 31.296331, lng: 34.239944 },
                        { lat: 31.296832, lng: 34.235571 }
                    ];

                    // Create the polygon
                    var areaBoundary = new google.maps.Polygon({
                        paths: areaCoordinates,
                        strokeColor: '#FF0000',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: '#FF0000EE',
                        fillOpacity: 0.35
                    });

                    // Set the polygon on the map
                    areaBoundary.setMap(map);
                }

                if (isPolygonExist === false) {
                    setPolygon();
                }
            }
            catch (err) {
                console.error(err);
            }

            try {
                let closed_schools_count = 0;
                let destroyed_schools_count = 0;
                let military_use_of_schools_count = 0;

                // For Title Translations
                let translatedTitles = {
                    'closed_schools': 'Closed Schools',
                    'destroyed_schools': 'Destroyed Schools',
                    'military_use_of_schools': 'Military Use of Schools'
                };

                let translatedTitlesAr = {
                    'closed_schools': 'المدارس المغلقة',
                    'destroyed_schools': 'المدارس المدمرة',
                    'military_use_of_schools': 'الاستخدام العسكري للمدارس'
                };

                let statisticsHolder = document.querySelector('.statistics-holder');      
                let cs_arabicText = 'مدرسة';
                let cs_englishText = 'schools';
                let ds_arabicText = 'مدرسة';
                let ds_englishText = 'schools';
                let ms_arabicText = 'مدرسة';
                let ms_englishText = 'schools';

                if (area === 'all') {

                    // Couning closed_schools
                    for (let all_areas_properties of Object.values(res)) {
                        if (all_areas_properties['closed_schools'] === undefined) {
                            continue;
                        }

                        closed_schools_count += all_areas_properties['closed_schools']['places'].length;
                    }

                    // Counting destroyed_schools
                    for (let all_areas_properties of Object.values(res)) {
                        if (all_areas_properties['destroyed_schools'] === undefined) {
                            continue;
                        }

                        destroyed_schools_count += all_areas_properties['destroyed_schools']['places'].length;
                    }

                    // Counting military_use_of_schools
                    for (let all_areas_properties of Object.values(res)) {
                        if (all_areas_properties['military_use_of_schools'] === undefined) {
                            continue;
                        }

                        military_use_of_schools_count += all_areas_properties['military_use_of_schools']['places'].length;
                    }

                    // Texts For closed_schools_count
                    if (closed_schools_count === 1) {
                        cs_arabicText = 'مدرسة';
                        cs_englishText = 'School';
                    }

                    if (closed_schools_count > 1) {
                        cs_arabicText = 'مدرسة';
                        cs_englishText = 'Schools';
                    }

                    if (closed_schools_count > 2 && closed_schools_count < 11 ) {
                        cs_arabicText = 'مدارس';
                    }

                    // Texts For destroyed_schools
                    if (destroyed_schools_count === 1) {
                        ds_arabicText = 'مدرسة';
                        ds_englishText = 'School';
                    }

                    if (destroyed_schools_count > 1) {
                        ds_arabicText = 'مدرسة';
                        ds_englishText = 'Schools';
                    }

                    if (destroyed_schools_count > 2 && destroyed_schools_count < 11 ) {
                        ds_arabicText = 'مدارس';
                    }

                    // Texts For military_use_of_schools
                    if (military_use_of_schools_count === 1) {
                        ms_arabicText = 'مدرسة';
                        ms_englishText = 'School';
                    }

                    if (military_use_of_schools_count > 1) {
                        ms_arabicText = 'مدرسة';
                        ms_englishText = 'Schools';
                    }

                    if (military_use_of_schools_count > 2 && military_use_of_schools_count < 11 ) {
                        ms_arabicText = 'مدارس';
                    }

                    statisticsHolder.innerHTML = `
                        ${closed_schools_count > 0 ?
                            `
                            <div class="stat-item closed_schools_stat" onclick="document.querySelector('#closed_schools').click()">
                                <div class="stat-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 38.992 45.704" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                                        <path id="Path_8" data-name="Path 8" d="M524.9,688.616l2.876,6.471a1.039,1.039,0,0,0,1.9,0l2.876-6.471a19.5,19.5,0,1,0-7.651,0Zm3.826-24.793a5.673,5.673,0,1,1-5.674,5.673A5.676,5.676,0,0,1,528.727,663.823Z" transform="translate(-509.231 -650)" fill="var(--marker-color)" fill-rule="evenodd"></path>
                                    </svg>
                                </div>

                                <div class="stat-info">
                                    <div class="stat-title">
                                        <span>${getLang === 'ar' ? translatedTitlesAr.closed_schools : translatedTitles.closed_schools}</span>
                                    </div>

                                    <div class="stat-value">
                                        <span>${closed_schools_count} ${getLang === 'ar' ? cs_arabicText : cs_englishText}</span>
                                    </div>
                                </div>
                            </div>` : ``
                        }

                        ${destroyed_schools_count > 0 ?
                            `
                            <div class="stat-item destroyed_schools_stat" onclick="document.querySelector('#destroyed_schools').click()">
                                <div class="stat-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 38.992 45.704" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                                        <path id="Path_8" data-name="Path 8" d="M524.9,688.616l2.876,6.471a1.039,1.039,0,0,0,1.9,0l2.876-6.471a19.5,19.5,0,1,0-7.651,0Zm3.826-24.793a5.673,5.673,0,1,1-5.674,5.673A5.676,5.676,0,0,1,528.727,663.823Z" transform="translate(-509.231 -650)" fill="var(--marker-color)" fill-rule="evenodd"></path>
                                    </svg>
                                </div>
    
                                <div class="stat-info">
                                    <div class="stat-title">
                                        <span>${getLang === 'ar' ? translatedTitlesAr.destroyed_schools : translatedTitles.destroyed_schools}</span>
                                    </div>
    
                                    <div class="stat-value">
                                        <span>${destroyed_schools_count} ${getLang === 'ar' ? ds_arabicText : ds_englishText}</span>
                                    </div>
                                </div>
                            </div>` : ``
                        }

                        ${military_use_of_schools_count > 0 ?
                            `
                            <div class="stat-item military_use_of_schools_stat" onclick="document.querySelector('#military_use_of_schools').click()">
                                <div class="stat-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 38.992 45.704" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                                        <path id="Path_8" data-name="Path 8" d="M524.9,688.616l2.876,6.471a1.039,1.039,0,0,0,1.9,0l2.876-6.471a19.5,19.5,0,1,0-7.651,0Zm3.826-24.793a5.673,5.673,0,1,1-5.674,5.673A5.676,5.676,0,0,1,528.727,663.823Z" transform="translate(-509.231 -650)" fill="var(--marker-color)" fill-rule="evenodd"></path>
                                    </svg>
                                </div>
    
                                <div class="stat-info">
                                    <div class="stat-title">
                                        <span>${getLang === 'ar' ? translatedTitlesAr.military_use_of_schools : translatedTitles.military_use_of_schools}</span>
                                    </div>
    
                                    <div class="stat-value">
                                        <span>${military_use_of_schools_count} ${getLang === 'ar' ? ms_arabicText : ms_englishText}</span>
                                    </div>
                                </div>
                            </div>` : ``
                        }  
                    `;
                }

                if (area !== 'all') {
                    // Counting closed_schools
                    closed_schools_count += res[area].closed_schools?.places.length;

                    // Counting destroyed_schools
                    destroyed_schools_count += res[area].destroyed_schools?.places.length;

                    // Counting military_use_of_schools
                    military_use_of_schools_count += res[area].military_use_of_schools?.places.length;

                    // Texts For closed_schools_count
                    if (closed_schools_count === 1) {
                        cs_arabicText = 'مدرسة';
                        cs_englishText = 'School';
                    }

                    if (closed_schools_count > 1) {
                        cs_arabicText = 'مدرسة';
                        cs_englishText = 'Schools';
                    }

                    if (closed_schools_count > 2 && closed_schools_count < 11 ) {
                        cs_arabicText = 'مدارس';
                    }

                    // Texts For destroyed_schools
                    if (destroyed_schools_count === 1) {
                        ds_arabicText = 'مدرسة';
                        ds_englishText = 'School';
                    }

                    if (destroyed_schools_count > 1) {
                        ds_arabicText = 'مدرسة';
                        ds_englishText = 'Schools';
                    }

                    if (destroyed_schools_count > 2 && destroyed_schools_count < 11 ) {
                        ds_arabicText = 'مدارس';
                    }

                    // Texts For military_use_of_schools
                    if (military_use_of_schools_count === 1) {
                        ms_arabicText = 'مدرسة';
                        ms_englishText = 'School';
                    }

                    if (military_use_of_schools_count > 1) {
                        ms_arabicText = 'مدرسة';
                        ms_englishText = 'Schools';
                    }

                    if (military_use_of_schools_count > 2 && military_use_of_schools_count < 11 ) {
                        ms_arabicText = 'مدارس';
                    }

                    statisticsHolder.innerHTML = `
                    ${closed_schools_count > 0 ?
                        `
                        <div class="stat-item closed_schools_stat" onclick="document.querySelector('#closed_schools').click()">
                            <div class="stat-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 38.992 45.704" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                                    <path id="Path_8" data-name="Path 8" d="M524.9,688.616l2.876,6.471a1.039,1.039,0,0,0,1.9,0l2.876-6.471a19.5,19.5,0,1,0-7.651,0Zm3.826-24.793a5.673,5.673,0,1,1-5.674,5.673A5.676,5.676,0,0,1,528.727,663.823Z" transform="translate(-509.231 -650)" fill="var(--marker-color)" fill-rule="evenodd"></path>
                                </svg>
                            </div>

                            <div class="stat-info">
                                <div class="stat-title">
                                    <span>${getLang === 'ar' ? translatedTitlesAr.closed_schools : translatedTitles.closed_schools}</span>
                                </div>

                                <div class="stat-value">
                                    <span>${closed_schools_count} ${getLang === 'ar' ? cs_arabicText : cs_englishText}</span>
                                </div>
                            </div>
                        </div>` : ``
                    }

                    ${destroyed_schools_count > 0 ?
                        `
                        <div class="stat-item destroyed_schools_stat" onclick="document.querySelector('#destroyed_schools').click()">
                            <div class="stat-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 38.992 45.704" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                                    <path id="Path_8" data-name="Path 8" d="M524.9,688.616l2.876,6.471a1.039,1.039,0,0,0,1.9,0l2.876-6.471a19.5,19.5,0,1,0-7.651,0Zm3.826-24.793a5.673,5.673,0,1,1-5.674,5.673A5.676,5.676,0,0,1,528.727,663.823Z" transform="translate(-509.231 -650)" fill="var(--marker-color)" fill-rule="evenodd"></path>
                                </svg>
                            </div>

                            <div class="stat-info">
                                <div class="stat-title">
                                    <span>${getLang === 'ar' ? translatedTitlesAr.destroyed_schools : translatedTitles.destroyed_schools}</span>
                                </div>

                                <div class="stat-value">
                                    <span>${destroyed_schools_count} ${getLang === 'ar' ? ds_arabicText : ds_englishText}</span>
                                </div>
                            </div>
                        </div>` : ``
                    }

                    ${military_use_of_schools_count > 0 ?
                        `
                        <div class="stat-item military_use_of_schools_stat" onclick="document.querySelector('#military_use_of_schools').click()">
                            <div class="stat-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 38.992 45.704" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                                    <path id="Path_8" data-name="Path 8" d="M524.9,688.616l2.876,6.471a1.039,1.039,0,0,0,1.9,0l2.876-6.471a19.5,19.5,0,1,0-7.651,0Zm3.826-24.793a5.673,5.673,0,1,1-5.674,5.673A5.676,5.676,0,0,1,528.727,663.823Z" transform="translate(-509.231 -650)" fill="var(--marker-color)" fill-rule="evenodd"></path>
                                </svg>
                            </div>

                            <div class="stat-info">
                                <div class="stat-title">
                                    <span>${getLang === 'ar' ? translatedTitlesAr.military_use_of_schools : translatedTitles.military_use_of_schools}</span>
                                </div>

                                <div class="stat-value">
                                    <span>${military_use_of_schools_count} ${getLang === 'ar' ? ms_arabicText : ms_englishText}</span>
                                </div>
                            </div>
                        </div>` : ``
                    }  
                `;
                }

            } catch (error) {
                console.log(error);
            }
        })
    } catch (err) {
        console.log(err);
    }
}

// Function to center the map on a marker
function centerMap(lat, lng) {
    map.setCenter(new google.maps.LatLng(lat, lng));
}

// Function to switch between property types
function openProperty(evt, propertyName) {
    var i, tabcontent, tablinks;

    // Hide all property types
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    // Remove active class from all tabs
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    // Show the selected property type
    document.getElementById(propertyName).style.display = "flex";
    evt.currentTarget.classList.add('active');

    // Update currentProperty variable
    currentProperty = propertyName;

    document.getElementById('property-items').innerHTML = '';

    // Reload markers for the selected property type and area
    loadMarkers(document.getElementById('area-dropdown').value, currentProperty);
}

// Event listener for area dropdown change
document.getElementById('area-dropdown').addEventListener('change', function () {
    // Reload markers for the selected area and current property type
    document.getElementById('property-items').innerHTML = '';
    loadMarkers(this.value, currentProperty);
});

// Toggle filters
function toggleFilters(toggleState) {
    let filtersHolder = document.querySelector('.filters');
    let burgerBtn = document.querySelector('.burger-menu');
    let filtersOverlay = document.querySelector('.popups-overlay');
    filtersOverlay.style.zIndex = 1;

    if (toggleState === 'close') {
        burgerBtn.classList.remove('toggle-active');
        filtersHolder.classList.remove('show-filters');
        filtersOverlay.classList.remove('active');
    }

    if (toggleState === 'open') {
        burgerBtn.classList.add('toggle-active');
        filtersHolder.classList.add('show-filters');
        filtersOverlay.classList.add('active');
    }

    if (toggleState === 'toggle') {
        burgerBtn.classList.toggle('toggle-active');
        filtersHolder.classList.toggle('show-filters');
        filtersOverlay.classList.toggle('active');
    }
}

// Load Properties Info
function loadPropertiesInfo() {
    let availableProperties;
    let infoPanelContainer = document.querySelector('.info-panel-tabs');

    // To decided 
    let addActiveTabClass = 0;

    typesData.then((type) => {
        availableProperties = Object.entries(type);
        availableTitles = Object.keys(type);

        // For Title Translations
        let translatedTitles = {
            'closed_schools': 'المدارس المغلقة',
            'destroyed_schools': 'المدارس المدمرة',
            'military_use_of_schools': 'الاستخدام العسكري للمدارس'
        };

        availableProperties.forEach((property) => {
            let theTranslatedTitle = translatedTitles[property[0]];

            infoPanelContainer.innerHTML += `
            <button data-content="${property[1]}" data-title="${getLang === 'ar' ? theTranslatedTitle : property[0].replace(/_/g, ' ')}" class="info-tab ${addActiveTabClass === 0 ? 'active-tab' : ''} ${property[0]}" data-id="${property[0]}" title="property info for ${property[0].replace(/_/g, ' ')}">
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 38.992 45.704" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                <path id="Path_8" data-name="Path 8" d="M524.9,688.616l2.876,6.471a1.039,1.039,0,0,0,1.9,0l2.876-6.471a19.5,19.5,0,1,0-7.651,0Zm3.826-24.793a5.673,5.673,0,1,1-5.674,5.673A5.676,5.676,0,0,1,528.727,663.823Z" transform="translate(-509.231 -650)" fill="var(--marker-color)" fill-rule="evenodd"></path>
                </svg>
            </button>
            `;

            addActiveTabClass++;
        })
    }).then(() => propertiesInfoHandler(infoPanelContainer, availableProperties));
}

function propertiesInfoHandler(infoPanelContainer) {
    let infoPanelResultContainer = document.querySelector('.info-tab-result');
    let infoTab = infoPanelContainer.querySelector('.info-tab');
    let initialInfoContent = infoTab.dataset.content;
    let initialInfoTitle = infoTab.dataset.title;

    infoPanelResultContainer.innerHTML = `<p class="the-title ${infoTab.dataset.id}">${initialInfoTitle}</p><p>${initialInfoContent}</p>`;

    let allInfoTabs = infoPanelContainer.querySelectorAll('.info-tab');
    let currentTabContent;

    allInfoTabs.forEach((tab) => {
        tab.addEventListener('click', function () {
            infoPanelContainer.querySelector('.active-tab').classList.remove('active-tab');
            this.classList.add('active-tab');
            currentTabContent = this.dataset.content;
            currentTabTitle = this.dataset.title;
            infoPanelResultContainer.innerHTML = `<p class="the-title ${tab.dataset.id}">${currentTabTitle}</p><p>${currentTabContent}</p>`;
        });
    });
}

function propertiesInfoPanelToggler(state) {
    let infoPanelTogglerBtn = document.querySelector('.info-btn');
    let infoPanelPopup = document.querySelector('.info-panel-holder');
    let filtersOverlay = document.querySelector('.popups-overlay');

    infoPanelTogglerBtn.addEventListener('click', function () {
        infoPanelPopup.classList.add('info-panel-opened');
        filtersOverlay.classList.add('active');
        filtersOverlay.style.zIndex = 3;
    });

    if (state === 'close') {
        infoPanelPopup.classList.remove('info-panel-opened');
        filtersOverlay.classList.remove('active');
        filtersOverlay.style.zIndex = -1;
    }
}

window.addEventListener('DOMContentLoaded', function () {
    /* ===[Start Toggle Menu]=== */
    let menuToggler = document.querySelector('.burger-menu');

    menuToggler.addEventListener('click', function () {
        toggleFilters('toggle');
    });
    /* ===[End Toggle Menu]=== */

    /* ===[Start Close Menu When Overlay Clicked]=== */
    document.querySelector('.popups-overlay').addEventListener('click', function () {
        toggleFilters('close');
        propertiesInfoPanelToggler('close');
    });
    /* ===[End Close Menu When Overlay Clicked]=== */

    /* ===[Start Add local storage about default language]=== */
    // Init Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Transition effect when changing gallery items
        Carousel: {
            transition: "slide",
        },
        // Disable image zoom animation on opening and closing
        Images: {
            zoom: true,
        },
        // Custom CSS transition on opening
        showClass: "f-fadeIn",
    });

    let langSwitcher = document.querySelector('select#lang');
    langSwitcher.value = getLang;

    langSwitcher.addEventListener('change', function () {
        localStorage.setItem('default_lang', this.value);
        window.location.reload();
    });

    document.documentElement.lang = getLang;
    /* ===[End Add local storage about default language]=== */

    /* ===[Start Generating the info panel tabs]=== */
    loadPropertiesInfo();
    /* ===[End Generating the info panel tabs]=== */

    /* ===[Start Handling Properties Info Panel Toggler]=== */
    propertiesInfoPanelToggler('open');

    let closeInfoPanel = document.querySelector('.close-info-panel');

    closeInfoPanel.addEventListener('click', function () {
        propertiesInfoPanelToggler('close');
    });
    /* ===[End Handling Properties Info Panel Toggler]=== */
});